import React, { useState, useRef, useEffect } from "react";

export function Combobox({ items, value, onChange, placeholder = "Selecione...", allowClear }) {
  const [search, setSearch] = useState("");
  const [open, setOpen] = useState(false);
  const inputRef = useRef(null);
  const filtered = items.filter(item =>
    item.label.toLowerCase().includes(search.toLowerCase())
  );

  useEffect(() => {
    if (!open) setSearch("");
  }, [open]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (inputRef.current && !inputRef.current.contains(event.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const selectedLabel = items.find(i => i.value === value)?.label ?? "";

  return (
    <div className="relative" ref={inputRef}>
      <input
        type="text"
        className="w-full border rounded px-3 py-2 focus:outline-none focus:ring focus:border-blue-300"
        placeholder={placeholder}
        value={open ? search : selectedLabel}
        onChange={e => {
          setSearch(e.target.value);
          setOpen(true);
        }}
        onFocus={() => setOpen(true)}
        readOnly={false}
        autoComplete="off"
      />
      {open && (
        <div className="absolute z-10 bg-white border w-full mt-1 rounded shadow max-h-48 overflow-auto">
          {filtered.length === 0 && (
            <div className="p-2 text-gray-500">Nenhum resultado</div>
          )}
          {filtered.map(item => (
            <div
              key={item.value}
              className={`p-2 hover:bg-blue-50 cursor-pointer ${item.value === value ? "bg-blue-100" : ""}`}
              onClick={() => {
                onChange(item.value);
                setOpen(false);
              }}
            >
              {item.label}
            </div>
          ))}
        </div>
      )}
      {allowClear && value && (
        <button
          type="button"
          className="absolute right-2 top-2 text-gray-400 hover:text-gray-600"
          onClick={() => {
            onChange("");
            setSearch("");
            setOpen(false);
          }}
        >
          ×
        </button>
      )}
    </div>
  );
} 